// extracted by mini-css-extract-plugin
export default {"loading_wrapper":"LoadingPage_loading_wrapper__FbHTJ","loading":"LoadingPage_loading__eOD9w","loading_img":"LoadingPage_loading_img__5KQyz"};